import { sendGoogleEvent, sendRequest } from '@html/_common/utils';
import AOTourRateTranslation from '@atomic/organisms/_common/rate-translation';

export default class AOWhatsIncluded {
  constructor(tourId, tdpEventCategory) {
    this.tourId = tourId;
    this.includedState = 'translated';
    this.included = { original: null, translated: null };
    this.TDP_EVENT_CATEGORY = tdpEventCategory;
    this.INCLUDED_SECTION_CLASS = '.js-ao-tour-included';
    this.INCLUDED_BLOCK_CLASS = '.js-ao-tour-included__included';
  }

  static initFoodTypes($container) {
    $('.js-ao-tour-included__included-item-included-meals-item', $container).each((index, element) => {
      const $currentElement = $(element);
      const title = $currentElement.prop('title');
      const isAvailable = !$currentElement.hasClass('food-unavailable');
      const availableText = isAvailable
        ? $container.data('food-available-text')
        : $container.data('food-not-available-text');
      $currentElement.data('tooltip', availableText.replace('{{foodType}}', title).replace('<b>', '').replace('</b>', ''));
    });

    $('.js-ao-tour-included__included-item-included-meals-item', $container).click((e) => {
      e.preventDefault();
      e.stopPropagation();
    });
  }

  initiate() {
    const $container = $(`${this.INCLUDED_SECTION_CLASS}`);
    AOWhatsIncluded.initFoodTypes($container);
    import(/* webpackChunkName: "AOScoutAccordion" */'@scout/components/accordion/accordion').then((module) => {
      const AOScoutAccordion = module.default;

      const accordion = new AOScoutAccordion({
        selector: this.INCLUDED_SECTION_CLASS,
        onCollapse: ({ eventCategory, blockName, sectionLabel }) => {
          sendGoogleEvent(
            eventCategory,
            blockName,
            `Collapse - ${sectionLabel}`,
            {
              ampEventName: 'tdp_whats_included_clicked',
              tdp_whats_included_clicked_element: `${sectionLabel}`,
            },
          );
        },
        onExpand: ({ eventCategory, blockName, sectionLabel }) => {
          sendGoogleEvent(
            eventCategory,
            blockName,
            `Expand - ${sectionLabel}`,
            {
              ampEventName: 'tdp_whats_included_clicked',
              tdp_whats_included_clicked_element: `${sectionLabel}`,
            },
          );
        },
      });
      const $toggleAllButton = $('.js-ao-tour-included__toggle-all');
      const ACCORDION_LIST_SELECTOR = `${this.INCLUDED_BLOCK_CLASS} .js-ao-scout-accordion`;
      const EXPANDED_CLASS = '.ao-scout-accordion--expanded';
      const COLLAPSED_CLASS = '.ao-scout-accordion--collapsed';

      $container.find('.js-ao-scout-accordion').click((e) => {
        const $clickedAccordionTitle = $(e.currentTarget).find('.js-ao-scout-accordion__title');
        if (!$clickedAccordionTitle.hasClass('initiated')) {
          $clickedAccordionTitle.find('.js-ao-scout-accordion__arrow').addClass('hid');
          $clickedAccordionTitle
            .addClass('initiated')
            .append('<div class="ao-scout-accordion__loader scout-loader-three-dots"><span class="scout-loader-three-dots__loader"></span></div>');
        }
        this.load(this.includedState, () => {
          $clickedAccordionTitle.find('.ao-scout-accordion__loader').remove();
          $clickedAccordionTitle.find('.js-ao-scout-accordion__arrow').removeClass('hid');

          /* Check if user manually closes/open all items */
          const allAccordions = $(ACCORDION_LIST_SELECTOR).length;
          const collapsedAccordions = $(`${this.INCLUDED_BLOCK_CLASS} ${COLLAPSED_CLASS}`).length;
          const expandedAccordions = $(`${this.INCLUDED_BLOCK_CLASS} ${EXPANDED_CLASS}`).length;

          if (allAccordions === collapsedAccordions) {
            $toggleAllButton.text($(this.INCLUDED_BLOCK_CLASS).data('expand-text'));
          } else if (allAccordions === expandedAccordions) {
            $toggleAllButton.text($(this.INCLUDED_BLOCK_CLASS).data('hide-text'));
          }
        });
      });

      $toggleAllButton.click((event) => {
        const $clickedElement = $(event.currentTarget);
        const isCurrentlyExpanded = $clickedElement.text() === $(this.INCLUDED_BLOCK_CLASS).data('expand-text');
        if (isCurrentlyExpanded) {
          $clickedElement.text($(this.INCLUDED_BLOCK_CLASS).data('hide-text'));
          $(`${this.INCLUDED_BLOCK_CLASS} .js-ao-scout-accordion__title:not(.initiated)`)
            .addClass('initiated')
            .append('<span class="ao-scout-accordion__loader"></span>');
          this.load(this.includedState, () => {
            const $listOfAccordions = $(ACCORDION_LIST_SELECTOR);
            accordion.accordions.toggleMultipleAccordions($listOfAccordions, 'expand');
            $(`${this.INCLUDED_BLOCK_CLASS} .js-ao-scout-accordion__title`).find('.ao-scout-accordion__loader').remove();
          });

          sendGoogleEvent(
            this.TDP_EVENT_CATEGORY,
            'What\'s included',
            'Expand All',
            {
              ampEventName: 'tdp_whats_included_clicked',
              tdp_whats_included_clicked_element: 'Expand All',
            },
          );
        } else {
          $clickedElement.text($(this.INCLUDED_BLOCK_CLASS).data('expand-text'));
          const $listOfAccordions = $(ACCORDION_LIST_SELECTOR);
          accordion.accordions.toggleMultipleAccordions($listOfAccordions, 'collapse');

          sendGoogleEvent(
            this.TDP_EVENT_CATEGORY,
            'What\'s included',
            'Collapse All',
            {
              ampEventName: 'tdp_whats_included_clicked',
              tdp_whats_included_clicked_element: 'Collapse All',
            },
          );
        }
      });

      $container.find('.translate-link').click((event) => {
        const link = $(event.currentTarget);
        if (link.parent('.translated-block').hasClass('original')) {
          this.load('translated', () => {
            $container.find('.translated-block.translated').removeClass('hid');
            $container.find('.translated-block.original').addClass('hid');
          });

          sendGoogleEvent(this.TDP_EVENT_CATEGORY, 'What\'s included', 'Translate');
        } else {
          this.load('original', () => {
            $container.find('.translated-block.translated').addClass('hid');
            $container.find('.translated-block.original').removeClass('hid');
          });

          sendGoogleEvent(this.TDP_EVENT_CATEGORY, 'What\'s included', 'Show original');
        }
      });

      const rateTranslation = new AOTourRateTranslation(this.common, $container);
      rateTranslation.initiate();
      accordion.initiate();
    });
  }

  load(includedState, callback) {
    const refreshIncluded = (this.includedState !== includedState);
    this.includedState = includedState;
    if (this.included[includedState] === null) {
      this.included[includedState] = {};
      $('body').addClass('wait');

      let url = `/api/tour/included/${this.tourId}`;
      if (includedState === 'original') url += '?original=1';

      sendRequest(url, {}, (data) => {
        $('body').removeClass('wait');

        if (data && data.success === true) {
          this.included[this.includedState] = data;
          this.fillIncluded(data);
        }
        setTimeout(callback, 10);
      }, { type: 'GET' });
    } else {
      if (refreshIncluded) this.fillIncluded(this.included[this.includedState]);

      callback();
    }
  }

  // eslint-disable-next-line class-methods-use-this
  fillIncluded = (data) => {
    for (let i = 0; i < data.included.length; i += 1) {
      const inc = data.included[i];
      const truncatedFieldName = inc.field_name.substr(0, 6);
      const $currentIncludedItem = $(`.js-ao-tour-included__included-item[data-id="${truncatedFieldName}"]`);
      const $currentNotIncludedItem = $(`.js-ao-tour-included__not-included-item[data-id="${truncatedFieldName}"]`);
      const contentBlock = `<div class='js-ao-tour-included__item-content ao-tour-included__item-content'>${inc.field_value}</div>`;

      if (inc.status === '1' && inc.included === '1') {
        if ($currentIncludedItem.length > 0) {
          $currentIncludedItem.find('.js-ao-tour-included__item-content').remove();
          $currentIncludedItem.append(contentBlock);
        }
      } else if (inc.status === '1' && (inc.included === '0' || inc.included === '' || inc.included === null)) {
        if ($currentNotIncludedItem.length > 0) {
          $currentNotIncludedItem.find('.js-ao-tour-included__item-content').remove();
          $currentNotIncludedItem.append(contentBlock);
        }
      }
    }

    const csPopupLink = $('.cs_popup');
    csPopupLink.on('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      $('.js-ao-tour-sticky-bar__cta--question,  .js-ao-tour-ask-expert-cta-banner__button, .js-ao-tour-bottom-banner__cta-ask, .js-ao-tour-start-planning-your-tour__cta-ask')
        .first()
        .click();
    });
  };
}
